module.exports = __webpack_public_path__ + "img/高阳纺织.e04604f0.jpg";